<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between">
        <span class="font-weight-bold"> {{ $t('manageplan.component.card.payment-method.creditCard') }}</span>
        <span class="font-weight-normal">
          <CIcon :name="selectedPayment.brand" size="custom-size" :height="30" viewBox="0 0 32 32" />
          {{ selectedPayment.label }}
        </span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="font-weight-bold"> {{ $t('manageplan.component.card.payment-method.subTotal') }}</span>
        <span class="font-weight-normal">{{ subTotal }} €</span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold"
          >{{ $t(`manageplan.component.card.subTotal.tax`) }}
          <CButton
            v-c-tooltip.hover="{
              content: `Placement`,
              placement: 'right-end',
            }"
            class="p-0 m-0"
          >
            <CIcon name="question" size="custom-size" :height="15" viewBox="0 0 32 32" class="mr-3" />
          </CButton>
        </span>
        <span class="text-gray-600">{{ivaCount}} %</span>
      </li>
    </ul>
  </CCardBody>
</template>

<script>
export default {
  name: 'CardPayment',
  props: {
    creditCard: {
      type: String,
      default: 'creditCard',
    },
    tax: {
      type: String,
      default: 'tax',
    },
    subTotal: {},
    phoneNumber: {
      type: String,
      default: 'phoneNumber',
    },
    iva: {
      type: String,
      default: 'iva',
    },
  },

  computed: {
    isSummary() {
      return this.place == 'summary'
    },

    selectedPayment() {
      return this.$store.state.balance.steps.selectPayment
    },

    ivaCount(){
      return this.$store.state.balance.steps.iva
    }
  },
}
</script>

<style lang="scss"></style>
